import { t } from '../../app/i18n';

export default {
  PERSON: 'PERSON',
  COMPANY: 'COMPANY',
};

export const translation = {
  PERSON: t('Fyzická osoba'),
  COMPANY: t('Právnická osoba'),
};



// WEBPACK FOOTER //
// ./src/common/enums/creditorTypes.js